export default __webpack_public_path__ + "static/chart-mobile-1-4c09c254e158dcd0f7430a96f8748e9f.webp";